import React, { useEffect, useState } from "react";
import s from "./detailsRemitos.module.css";
//Servicios
import providersService from "../../../../api/providers/providersService";
import couponsService from "../../../../api/delivery/couponsService";
//assets
import { dateFormats } from "../../../../helpers/convertDate";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
//Material
import CircularProgress from "@mui/material/CircularProgress"
import Grid from "@mui/material/Grid"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import gamesService from "../../../../api/games/GamesService";
import useTranslationException from "../../../../helpers/exceptions";

// ========================= | DETAILS REMITOS | ==============================

export const DetailsRemitos = ({ form, setItemSelected }) => {
  const showExpetion = useTranslationException();

  const { textColor } = useSelector((state) => state.local);

  const navigate = useNavigate();

  const [deliveryEntity, setDeliveryEntity] = useState(null);
  const [loading, setLoading] = useState(false);
  const [games, setGames] = useState([]);

  useEffect(() => {
    // Log para debug: verificar estructura del remito
    console.log("📋 Estructura completa del remito recibida:", JSON.stringify(form, null, 2));
    console.log("📋 Campos específicos del remito:", {
      date: form?.date,
      agency: form?.agency,
      agencyId: form?.agencyId,
      agencyName: form?.agencyName,
      supplierId: form?.supplierId,
      supplierName: form?.supplierName,
      type: form?.type,
      state: form?.state,
      detailList: form?.detailList?.length || 0,
      createdDate: form?.createdDate,
      lastModifiedDate: form?.lastModifiedDate
    });
    
    setLoading(true);
    gamesService
      .getAllGames()
      .then((res) => setGames(res.content))
      .then(() => {
        if (form.supplierId) {
          providersService
            .getSupplierById(form.supplierId)
            .then((res) => setDeliveryEntity(res))
            .then(() => setLoading(false));
        } else if (form.agency && form.agency.id) {
          couponsService.getAgencyById(form.agency.id)
            .then((res) => setDeliveryEntity(res))
            .then(() => setLoading(false));
        } else if (form.agencyId) {
          couponsService.getAgencyById(form.agencyId)
            .then((res) => setDeliveryEntity(res))
            .then(() => setLoading(false));
        } else {
          console.warn("No se encontró información de agencia o proveedor en el remito:", form);
          setLoading(false);
        }
      })
      .catch((e) => {
        showExpetion.showErrorModalForServiceException(
          e,
          { icon: "warning" },
          t("anErrorOccurred,TryAgain"),
          t("sorryErrorOcurred"),
        );
        setLoading(false);
      });
  }, []);

  return (
    <Grid item container xs={10} className={s.container} sx={{ mt: 5, mb: 5 }}>
      <Grid item container xs={12} sx={{ alignItems: "flex-start" }}>
        <Grid item xs={12}>
          <ArrowBackIcon
            sx={{ color: "primary.main", fontSize: "2rem" }}
            onClick={() => {
              setItemSelected({});
              navigate("../remitos");
            }}
            className={s.arrow}
          />
        </Grid>
        <Grid item xs={7} sx={{ mt: 2 }}>
          <h4 style={{ margin: 0, fontSize: "1.5rem", fontWeight: 400 }}>
            {t("deliveryNote")} N°{" "}
            {form.type === "Salida" 
              ? (form.nroOutput || form.id || form.number || "-")
              : (form.nroInput || form.id || form.number || "-")}
          </h4>
          <p
            style={{
              margin: 0,
              marginTop: "5px",
              fontSize: "1.2rem",
              fontWeight: 300,
              opacity: 0.7,
            }}
          >
            {t("details")}
          </p>
        </Grid>
        <Grid
          item
          xs={4}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "start",
            mt: 2,
          }}
        >
          <p
            style={{
              margin: 0,
              marginTop: "5px",
              fontSize: "1.3rem",
              fontWeight: 400,
            }}
          >
            {t("date")}:
          </p>
          <p
            style={{
              margin: 0,
              marginTop: "5px",
              marginLeft: "10px",
              fontSize: "1.3rem",
              fontWeight: 300,
            }}
          >
            {(() => {
              // Buscar fecha en varios campos posibles, priorizando date
              const dateValue = form.date 
                || form.deliveryDate 
                || form.approvalDate 
                || form.requestDate 
                || form.createdDate
                || form.lastModifiedDate
                || (form.detailList && form.detailList[0]?.deliveryDate);
              
              if (!dateValue) return "-";
              
              // Si es string, extraer solo la fecha (antes de la T)
              if (typeof dateValue === 'string') {
                return dateValue.split("T")[0];
              }
              
              // Si es Date object, formatear
              if (dateValue instanceof Date) {
                return dateValue.toISOString().split("T")[0];
              }
              
              return dateValue;
            })()}
          </p>
        </Grid>
      </Grid>

      {loading ? (
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
          }}
        >
          <CircularProgress size="2rem" />
        </Grid>
      ) : (
        <>
          <Grid item container xs={12} className={s.init}>
            <Grid item xs={3} className={s.item}>
              <h4>{t("type")}</h4>
              <p>
                {form.type}{" "}
                {form.type === "Salida"
                  ? form.supplierId
                    ? `(${t("returnToProvider")})`
                    : `(${t("distribution")})`
                  : form.supplierId
                    ? `(${t("income")})`
                    : `(${t("return")})`}
              </p>
            </Grid>
            <Grid item xs={3} className={s.item}>
              <h4>{t("state")}</h4>
              <p>{form.state}</p>
            </Grid>
            <Grid item xs={3} className={s.item}>
              <h4>{t("shipperAddress")}</h4>
              <p>
                {form.type === "Salida"
                  ? form.storeRemit || "-"
                  : form.supplierId
                    ? `${form.supplierName || "-"}`
                    : `${form.agencyName || form.agency?.name || "-"}`}
              </p>
              <p className={s.address}>
                {form.type === "Salida"
                  ? ""
                  : form.supplierId
                    ? `${deliveryEntity?.address || ""} ${deliveryEntity?.numberAddress || ""}`.trim() || "-"
                    : `${deliveryEntity?.address?.street || ""} ${deliveryEntity?.address?.number || ""}`.trim() || "-"}
              </p>
            </Grid>
            <Grid item xs={3} className={s.item}>
              <h4>{t("destination")}</h4>
              <p>
                {form.type === "Entrada"
                  ? form.storeReceptor || "-"
                  : form.supplierId
                    ? `${form.supplierName || "-"}`
                    : `${form.agencyName || form.agency?.name || "-"}`}
              </p>
              <p className={s.address}>
                {form.type === "Entrada"
                  ? ""
                  : form.supplierId
                    ? `${deliveryEntity?.address || ""} ${deliveryEntity?.numberAddress || ""}`.trim() || "-"
                    : `${deliveryEntity?.address?.street || ""} ${deliveryEntity?.address?.number || ""}`.trim() || "-"}
              </p>
            </Grid>
          </Grid>

          <Grid item xs={12} className={s.init}>
            <h4
              style={{
                fontSize: "1.2rem",
                fontWeight: "400",
                marginTop: "20px",
                marginBottom: "5px",
              }}
            >
              {t("observations")}
            </h4>
            <p
              style={{
                fontSize: "1.1rem",
                fontWeight: "300",
                margin: 0,
                marginTop: "5px",
              }}
            >
              {form.observations || "Sin observaciones"}
            </p>
          </Grid>

          <Grid item xs={12} className={s.init}>
            <h4
              style={{
                fontSize: "1.2rem",
                fontWeight: "400",
                marginTop: "20px",
                marginBottom: "5px",
              }}
            >
              {t("purchaseOrder")}
            </h4>
            <p
              style={{
                fontSize: "1.1rem",
                fontWeight: "300",
                margin: 0,
                marginTop: "5px",
              }}
            >
              {form.orderId || t("noPurchaseOrder")}
            </p>
          </Grid>

          <Grid item xs={12} sx={{ my: 3 }}>
            <h4
              style={{
                fontSize: "1.2rem",
                fontWeight: "400",
                marginTop: "5px",
                marginBottom: "15px",
              }}
            >
              {t("details")}
            </h4>
            {form?.detailList?.length ? (
              <TableContainer className={s.tableContainer}>
                <Table>
                  <TableHead sx={{ backgroundColor: "primary.main" }}>
                    <TableCell
                      sx={{
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >
                      {t("quantity")}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >{`${t("coupons")}`}</TableCell>
                    <TableCell
                      sx={{
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >
                      {t("game")}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                    >
                      {t("drawNumber")}/{t("serie")}
                    </TableCell>
                  </TableHead>
                  <TableBody>
                    {form?.detailList?.map((item, i) => (
                      <React.Fragment key={i}>
                        <TableRow>
                          <TableCell sx={{ fontSize: ".9rem" }}>
                            {item.amount}
                          </TableCell>
                          <TableCell sx={{ fontSize: ".9rem" }}>
                            {item.nroCouponFrom}-{item.nroCouponTo}
                          </TableCell>
                          <TableCell sx={{ fontSize: ".9rem" }}>
                            {games?.find(
                              (i) => i.modality?.game?.id === item.gameId,
                            )
                              ? games?.find(
                                (i) => i.modality?.game?.id === item.gameId,
                              ).modality.game.name
                              : "-"}
                          </TableCell>
                          <TableCell sx={{ fontSize: ".9rem" }}>
                            {item.raffle?.number ||
                              item.raffle?.serie ||
                              "-"}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Grid
                item
                xs={12}
                sx={{
                  fontSize: "1.5rem",
                  fontWeight: 300,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100px",
                }}
              >
                {t("noDetails")}
              </Grid>
            )}
          </Grid>
        </>
      )}
    </Grid>
  );
};
